export const PURCHASE_REQUEST_RESOURCE = 'Procurement::PurchaseRequest'
